//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    fill: {
      type: String,
      default: "black",
    },
    width: {
      type: String,
      default: "20",
    },
    height: {
      type: String,
      default: "15",
    },
  },
};
